import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../Actions/loginAction";
import { BILLING_COMPONENT } from "../Billing/billingPageWrapper";
import { DASHBOARD_COMPONENT } from "../Dashboard/dashboardWrapper";
import { PROFILE_COMPONENT } from "../Profile/profilePageWrapper";
import { PAYMENT_COMPONENT } from "../Payments/paymentsWrapper";
import { getOrgNameBasedOnLevel } from "../../Util/dataHelper";
import { NOTIFICATIONS_COMPONENT } from "../Notifications/notificationsWrapper";
import { ENTERPRISE } from "../../Enums/administratorLevels";
import { REPORTS_COMPONENT } from "../Reports/reportsWrapper";
import { leftSideBarSelector } from "../../Reducers/leftSideBarReducer";
import {
  LEFT_SIDE_BAR_SELECTED,
  selectedComponentSelector,
} from "../../Reducers/selectedComponentReducer";
import AiIcon from "../Icons/ai-icon";
import BetaBadge from "../CommonComponents/BetaBadge";
import { AI_INSIGHTS } from "../AiInsights/AiInsightWrapper";
import { REVIEWS } from "../Reviews/ReviewsPageWrapper";
import { enterpriseDetailsSelector } from "../../Reducers/enterpriseDetailsReducer";
import styles from "./layout.module.css";
import { cx } from "../../Util/classHelpers";
import AccountsIcon from "../Icons/accounts-icon";
import ReportIcon from "../Icons/report-icon";
import StarIconV2 from "../Icons/star-icon-v2";
import BillingIcon from "../Icons/billing-icon";
import PaymentsIcon from "../Icons/payments-icon";
import { ACCOUNTS_COMPONENT } from "../Accounts/AccountsWrapper";
import FilledSettingsIcon from "../Icons/filled-settings-icon";
import { ADMIN } from "../../Enums/accessLevels";
import { SETTINGS_COMPONENT } from "../Settings/SettingsWrapper";
import { ownPermissionsSelector } from "../../Reducers/ownRoleReducer";
import { ORDERS_COMPONENT } from "../Orders/OrdersWrapper";

const PARTNER_TYPE_AFFILIATE = "AFFILIATE";
const PARTNER_TYPE_RESELLER = "RESELLER";

const LeftNavbar = () => {
  const sideBarActive = useSelector(leftSideBarSelector);
  const partnerDetails = useSelector(enterpriseDetailsSelector);
  const globalSelectedComponent = useSelector(selectedComponentSelector);
  const ownPermissions = useSelector(ownPermissionsSelector);
  const [selectedComponent, setSelectedComponent] =
    useState(DASHBOARD_COMPONENT);
  const dispatch = useDispatch();

  const setActiveComponent = (component) => {
    dispatch({
      type: LEFT_SIDE_BAR_SELECTED,
      payload: component,
    });
  };

  useEffect(() => {
    dispatch({
      type: LEFT_SIDE_BAR_SELECTED,
      payload: ACCOUNTS_COMPONENT,
    });
  }, []);

  useEffect(() => {
    if (
      globalSelectedComponent !== null &&
      globalSelectedComponent !== selectedComponent
    ) {
      setSelectedComponent(globalSelectedComponent);
    }
  }, [globalSelectedComponent, selectedComponent]);

  if (partnerDetails === null) return <></>;

  const navBarConfig = [
    {
      component: ACCOUNTS_COMPONENT,
      icon: <AccountsIcon />, 
      label: "Accounts",
    },
    {
      component: ORDERS_COMPONENT,
      icon: <i className="bi bi-shop icon-large" />,
      label: "Orders",
    },
    {
      component: REPORTS_COMPONENT,
      icon: <ReportIcon />,
      label: "Reports",
      show: ownPermissions.canReadReports(),
    },
    {
      component: AI_INSIGHTS,
      icon: <AiIcon />,
      label: "AI Insights",
    },
    {
      component: REVIEWS,
      icon: <StarIconV2 />,
      label: "Reviews",
      show: ownPermissions.canManageReviews(),
    },
    {
      component: NOTIFICATIONS_COMPONENT,
      icon: <i className="bi bi-megaphone icon-large" />,
      label: "Notifications",
      show: partnerDetails.getAdminLevel() === ENTERPRISE && ownPermissions.canManageNotifications(),
    },
    {
      component: BILLING_COMPONENT,
      icon: <BillingIcon />,
      label: "Billing & Usage",
      show: ownPermissions.canReadBilling(),
    },
    {
      component: PAYMENT_COMPONENT,
      icon: <PaymentsIcon />,
      label: "Payment",
      show: ownPermissions.canManagePayments(),
    },
    {
      component: SETTINGS_COMPONENT,
      icon: <FilledSettingsIcon />,
      label: "Settings",
      show: partnerDetails.getAdminLevel() === ENTERPRISE && ownPermissions.canManageUsers(),
    },
    // {
    //   component: PROFILE_COMPONENT,
    //   icon: <i className="bi bi-person icon-large" />,
    //   label: "Profile",
    // },
    // {
    //   component: "logout",
    //   icon: <i className="bi bi-box-arrow-right icon-large" />,
    //   label: "Logout",
    //   onClick: () => dispatch(logout()),
    // },
  ];

  return (
    <div className={cx(styles.sideNavbar, !sideBarActive && styles.sideNavbarCollapsed)}>
      <div className={styles.navLinkList}>
        {navBarConfig.map(
          (item, index) =>
            (item.show === undefined || item.show) && (
              <div
                key={index}
                className={cx(
                  styles.navLink,
                  selectedComponent === item.component && styles.navLinkSelected
                )}
                onClick={() =>
                  item.onClick
                    ? item.onClick()
                    : setActiveComponent(item.component)
                }
              >
                <div className={cx(styles.navLinkIcon)}>{item.icon}</div>
                <div className={cx(styles.navLinkLabel, !sideBarActive && styles.navLinkLabelCollapsed)}>{item.label}</div>
              </div>
            )
        )}
      </div>
    </div>
  );
};

export default LeftNavbar;
export {
  LEFT_SIDE_BAR_SELECTED,
  PARTNER_TYPE_AFFILIATE,
  PARTNER_TYPE_RESELLER,
};
